<template>
    <div class="w-10 h-10 p-2 bg-black rounded-full m-auto text-white uppercase text-md text-center">
        <span class="m-auto">{{getAvatarName()}}</span> 
    </div>
</template>

<script lang="ts">

export default {
  name: 'AvatarName',
  props: {
    name: { type: String, required: true, default: ''},
  },
  setup (props: any) {


    const getAvatarName = () => {
      let original = props.name.toLowerCase().split(' ');

        let first = original[0][0];
        let second = original.length > 2 ? original[2][0] : original.length === 2 ? original[1][0] : original[0][1]


        return first + second;

    }

    return {
      getAvatarName
    }

  }
}

</script>
